import React, { Component } from 'react';
import { addTestPoint, getBenchDetails, getAllScenarioGroupNames} from './UserFunctions'
import PopupModal from './PopupModal.js'

class AddTestPoint extends Component{
    constructor(props){
        super(props)
        this.state = {
            scenario_group_name : "",
            bench_id : "",
            showpopup : false,
            status : "",
            bench_details : [],
            group_name_list : [],
            selected_bench_name : "",
            selected_bench_id : "",
        }

        this.onhandleChangeGroupName = this.onhandleChangeGroupName.bind(this)
        this.onhandleChangeBenchId = this.onhandleChangeBenchId.bind(this)
        this.handleAdd = this.handleAdd.bind(this)
        this.togglePopup = this.togglePopup.bind(this)
        this.onhandleChangeBenchName = this.onhandleChangeBenchName.bind(this)
    }

    togglePopup(){
        this.setState({
            status : "",
            showpopup : false
        })
    }

    onhandleChangeBenchName(e){
        this.setState({
            selected_bench_name : e.target.value
        })
        this.state.bench_details.forEach((index) =>{
            if (index['bench_name'] === e.target.value){
                this.setState({
                    selected_bench_id : index['bench_id']
                })
            }
        })
        // this.state.bench_details.map((index)=>{
        //     if (index['bench_name'] === e.target.value){
        //         this.setState({
        //             selected_bench_id : index['bench_id']
        //         })
        //     }
        // })
    }
    onhandleChangeBenchId(e){
        this.setState({
            bench_id : e.target.value
        })
    }

    onhandleChangeGroupName(e){
        this.setState({
            scenario_group_name : e.target.value
        })
    }

    handleAdd(e){
        e.preventDefault();
        console.log("ScenarioGroupName : ", this.state.scenario_group_name)
        console.log("Bench Id : ", this.state.bench_id)

        const goto_url = (window.location.origin).concat('/add_test_point')
        const payload = {
            scenario_group_name : this.state.scenario_group_name,
            bench_id : parseInt(this.state.selected_bench_id)
        }

        addTestPoint(payload, goto_url).then(res => {
            console.log("response after addition : ", res)
            this.setState({
                    status : res['data']['status_message'],
                    showpopup : !this.state.showpopup

            })
        })
    }

    componentDidMount(){
        const bench_url = (window.location.origin).concat('/get_bench_details')

        getBenchDetails(bench_url).then(res => {
            console.log(res.data['data'])
            this.setState({
                bench_details : res.data['data']
            })
        })

        const group_name_url = (window.location.origin).concat('/get_scenario_group_names')
        getAllScenarioGroupNames(group_name_url).then(response=>{
            console.log("Response : ",response)
            console.log(response.data['data'])
            this.setState({
                group_name_list : response.data['data']
            })

        })

    }

    render(){
        return(
            <div data-test = 'addTestPointComponent'>
            <div className="container">
                <div className="row">
                  <div className="col mt-5 mx-auto">
                    <div className="card" style={{backgroundColor: "white"}}>
                        <div className="card">
                            <h2 className="card-header" style={{ color:"white" , fontSize: "100% !important", backgroundColor : "#757AF7"}}> Add Test Point </h2>
                        </div>
                    <div className="card-body">
                <form>
                    <div className="form-group">
                            <label htmlFor="group_id" className="col-form-label" style={{ color: "#464646"}}>Scenario Group Name</label>
                            <select id="inputState" className="form-control" value={this.state.scenario_group_name} onChange={(e) => this.onhandleChangeGroupName(e)}>
                                 <option>Select</option>
                                {this.state.group_name_list.map((key,i)=>{
                                    return (
                                        <option value={key} key={i}>{key}</option>
                                    )
                                })}
                           </select>
                    </div>
                    <div className="form-group">
                            <label htmlFor="group_id" className="col-form-label" style={{ color: "#464646"}}>Bench Name</label>
                            <select id="inputState" className="form-control" value={this.state.selected_bench_name} onChange={(e) => this.onhandleChangeBenchName(e)}>
                                 <option>Select</option>
                                 {this.state.bench_details.map((index,i)=>{
                                     return (
                                         <option value={index['bench_name']} key={i}>{index['bench_name']}</option>
                                     )
                                 })}
                           </select>
                    </div>
                    <div className="form-group">
                       <button type="submit" className="btn" onClick={(e) => this.handleAdd(e)}>Add</button>
                     </div>
                </form>
                </div>
                </div>
            </div>
            </div>
            </div>
             {this.state.showpopup ? <PopupModal text={this.state.status} closePopup={this.togglePopup.bind(this)} />: ""}
            </div>
            )
    }
}
// componentDidMount() {
//     this.setState( (prevState) => {
//         if(this.props.content){
//             return{
//                 scenario_id: this.props.content.scenario_id,
//                 scenario_group_name: this.props.content.scenario_group_name,
//                 scenario_uuid: this.props.content.scenario_uuid,
//                 scenario_name: this.props.content.scenario_name
//             }
//         } else {
//             return {
//                 scenario_id: "",
//                 scenario_group_name: "",
//                 scenario_uuid: "",
//                 scenario_name: ""
//             }
//         }
//     })
// }

// onScenarioUUIDChange = (e) => {
//     const scenario_uuid = e.target.value;
//     this.setState(() => ({scenario_uuid}));
// }

// onScenarioNameChange = (e) => {
//     const scenario_name = e.target.value;
//     this.setState(() => ({scenario_name}))
// }

// onSubmit = (e) => {
//     e.preventDefault();
//     const submitValue = {
//         scenario_id: this.state.scenario_id,
//         scenario_group_name: this.state.scenario_group_name,
//         scenario_uuid: this.state.scenario_uuid,
//         scenario_name: this.state.scenario_name,
//         scenario_group_scenario_mapping_id: this.props.content.scenario_group_scenario_mapping_id,
//         sequence: this.props.content.sequence,
//         scenario_group_id: this.props.content.scenario_group_id
//     }
//     //console.log(this.state);
// //        updateScenarioGroupDetails(submitValue).then( (response)=> {
// //            console.log(response);
// //        })

//     const edit_api_url = (window.location.origin).concat('/edit')
//     const data_for_api = {
//         scenario_uuid : submitValue['scenario_uuid'],
//         scenario_description : submitValue['scenario_name']
//     }
//     editDb(edit_api_url, data_for_api).then(res => {
//         console.log("Status of updation : ", res['data']['status'])
//         if(res['data']['status'] === "Updated Successfully"){
//             this.props.dispatch(editScenarioGroupData(submitValue));
//             this.props.handleEditModalClose();
//         }

//     })

//     //this.props.dispatch(editScenarioGroupData(submitValue));
//     //this.props.handleEditModalClose();
// };

export default AddTestPoint
